export enum AppMode {
    WEB = 'WEB',
    SA = 'SA',
    CS = 'CS'
}
